import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NavMenu } from '../interfaces/nav-menu';
import { NavMenuApiService } from './../services/nav-menu-api.service';
import * as NavMenuActions from './nav-menu.actions';

@Injectable()
export class NavMenuEffects {
  loadNavMenus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NavMenuActions.loadNavMenus),
      switchMap(payload => this.navMenuApiService.watchItems<NavMenu[]>().pipe(
        map(data => NavMenuActions.loadNavMenusSuccess({ data })),
        catchError(error => of(NavMenuActions.loadNavMenusFailure({ error })))
      )));
  });

  constructor(
    private actions$: Actions,
    private navMenuApiService: NavMenuApiService,
  ) { }
}
